import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NoteDTO } from '../../core/models/dto/note.dto';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'textForNotesExpander' })
export class TextForNotesExpanderPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(note: NoteDTO, subNotesLength: number, highlightedNoteId: number): string {
        let repliesCount;

        if (highlightedNoteId) {
            const itemIndex = note.subNotes.findIndex((item) => {
                return item.id === highlightedNoteId;
            });

            if (itemIndex > -1) {
                repliesCount = itemIndex;

                if (repliesCount === 0) {
                    note.areCommentsShown = !note.areCommentsShown;
                }
            } else {
                repliesCount = subNotesLength - 1;
            }
        } else {
            repliesCount = subNotesLength - 1;
        }

        if (repliesCount === 1) {
            return this.translateService.instant('1 more note');
        } else {
            return repliesCount + ' ' + this.translateService.instant('more notes');
        }
    }
}
